// Build stamp baked in at image build time (Dockerfile: ARG GIT_SHA ->
// ENV VITE_GIT_SHA); absent on local dev builds, where the stamp degrades
// to just the mode name.
const sha = import.meta.env.VITE_GIT_SHA || undefined;

export const buildInfo = {
    environment: import.meta.env.MODE,
    sha,
    commitUrl: sha && `https://github.com/ionq/cloud-apps/commit/${sha}`,
} as const;
